import { styleOverrides } from "./styleOverrides";

const MuiSwitch = {
  styleOverrides,
};

export { MuiSwitch };
